module.exports = __webpack_public_path__ + "media/mountains.ef760756.ogg";